import React from 'react'
import { useDeleteRequest } from '../../hooks/request'
import { EMPLOYEES_SALARY_DETAIL } from '../../urls'
import { useModal } from '../../hooks/modal'
import Button from '../../components/common/Button'
import { getMonths } from '../../utils/types'
import EmployeeSalaryUpdate from './EmployeeSalaryUpdate'

export default function EmployeeSalaryItem({ item, category, index }) {
    const brandRemove = useDeleteRequest({ url: EMPLOYEES_SALARY_DETAIL.replace('{id}', item.id) })
    const [showUpdateModal, hideUpdateModal] = useModal(
        <EmployeeSalaryUpdate
            category={category}
            item={item}
            onSuccess={() => {
                category.request()
                hideUpdateModal()
            }}
            onCancel={() => hideUpdateModal()}
        />,
    )

    async function remove() {
        if (global.confirm('Сизни чинакамдан ўчиришни истайсизми?')) {
            await brandRemove.request()
            await category.request()
        }
    }

    return (
        <tr>
            <td>{index + 1}</td>
            <td>{item.employeeName}</td>
            <td>{item.paymentDate}</td>
            <td>{item.amount}</td>
            <td>{item.daysWorked}</td>
            <td>{getMonths(item.month)}</td>
            <td>{item.year}</td>
            <td>{item.note}</td>
            <td>
                <div className="has-text-right is-flex">
                    <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small" icon="pencil-outline" />
                    <Button onClick={remove} className="button is-danger mr-2 is-outlined is-small" icon="trash" />
                </div>
            </td>
        </tr>
    )
}
